export enum PaginatedListItemNames {
  TAX = 'tax',
  CATEGORY = 'category',
  ITEM = 'item',
  SERVICE_CHARGE = 'service charges'
}
